// extracted by mini-css-extract-plugin
export default {"Promo__Section":"Promo_Promo__Section__WWLIH","Promo__Box":"Promo_Promo__Box__deTQa","Promo__Title":"Promo_Promo__Title__41PY5"};